import React, { useEffect, useState } from "react";
import SectionHeading from "../../common/headings/SectionHeading";
import { UrlProvider } from "../../../utils/UrlProvider";

const Header = ({ headingData }) => {
  const { heading, heading_color, underline } =
    headingData !== undefined || null && headingData;
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const componentPosition = document.getElementById("why-invest").offsetTop;
      const componentHeight =
        document.getElementById("why-invest").offsetHeight;

      // Check if the component is in the viewport
      if (
        scrollPosition + window.innerHeight > componentPosition &&
        scrollPosition < componentPosition + componentHeight
      ) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    // Listen for scroll events
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div id="why-invest" className="text-center md:w-[90%] w-[62%] m-auto">
      <SectionHeading lable={heading} lable_color={heading_color} />
      <div className="">
        <img
          className={`h-[2.5vw] md:h-[0.7vw] transition-all duration-1000 ${
            isVisible
              ? "opacity-100 md:translate-x-[45vw] translate-x-[6vw] w-[50vw] md:w-[25vw]"
              : "opacity-0 -translate-x-[5vw] w-0"
          }`}
          src={UrlProvider(underline?.url)}
          alt={underline?.alternativeText}
        />
      </div>
    </div>
  );
};

export default Header;
